import { MedewerkerType } from "../../enums";

// Weergavevolgorde: arts altijd bovenaan, daarna assistent, PM en inplanner;
// overige rollen volgen in enum-volgorde.
const ROLE_SORT_PRIORITY: Record<string, number> = (() => {
  const expliciet: MedewerkerType[] = [
    MedewerkerType.ARTS,
    MedewerkerType.ASSISTENT,
    MedewerkerType.PM,
    MedewerkerType.INPLANNER,
  ];
  const map: Record<string, number> = {};
  expliciet.forEach((rol, index) => {
    map[rol] = index;
  });
  let volgende = expliciet.length;
  Object.values(MedewerkerType).forEach((rol) => {
    if (!(rol in map)) {
      map[rol] = volgende++;
    }
  });
  return map;
})();

export function getRoleSortIndex(rol?: MedewerkerType | string | null): number {
  if (!rol) return Number.MAX_SAFE_INTEGER;
  return ROLE_SORT_PRIORITY[rol as string] ?? Number.MAX_SAFE_INTEGER;
}

export function getHighestPriorityRole(
  rollen: Array<MedewerkerType | string>,
): MedewerkerType | string | undefined {
  return [...rollen].sort(
    (a, b) => getRoleSortIndex(a) - getRoleSortIndex(b),
  )[0];
}

export function compareByRoleThenName<T>(
  getRol: (item: T) => MedewerkerType | string | null | undefined,
  getNaam: (item: T) => string,
): (a: T, b: T) => number {
  return (a, b) => {
    const verschil = getRoleSortIndex(getRol(a)) - getRoleSortIndex(getRol(b));
    if (verschil !== 0) return verschil;
    return getNaam(a).localeCompare(getNaam(b), "nl");
  };
}

export function getRoleDisplayNameLower(role: MedewerkerType | string): string {
  const roleNames: Record<string, string> = {
    [MedewerkerType.ARTS]: "arts",
    [MedewerkerType.ASSISTENT]: "assistent",
    [MedewerkerType.WAARNEMEND_ASSISTENT]: "waarnemend assistent",
    [MedewerkerType.VOORBEREIDINGS_ASSISTENT]: "voorbereidings assistent",
    [MedewerkerType.RADIOLOGIE_ASSISTENT]: "radiologie assistent",
    [MedewerkerType.PM]: "pm",
    [MedewerkerType.INPLANNER]: "inplanner",
    [MedewerkerType.MANAGER]: "manager",
    [MedewerkerType.FINANCIELE_MANAGER]: "financiële manager",
    [MedewerkerType.ADMIN]: "admin",
    [MedewerkerType.OVERIG]: "overig",
    [MedewerkerType.WEBINAR_MANAGER]: "webinarmanager",
  };
  return roleNames[role as string] || String(role).toLowerCase();
}
